export default __webpack_public_path__ + "static/media/photo--lg--18.e4271b85.jpg";